import React from 'react';

type TableCellProps = {
    children: React.ReactNode;
    rowIndex: number;
    onClick?: () => void;
    id: string;
    sticky?: boolean;
    style?: React.CSSProperties;
    className?: string;
    title?: string;
}

const TableCell = ({ children, rowIndex, onClick, id, sticky, style, className, title }: TableCellProps) => {
    return (
        <td
            id={`${id}`}
            className={`table-item-style tw-align-top tw-truncate ${onClick ? 'tw-text-primary tw-cursor-pointer' : ''} ${sticky ? 'tw-sticky tw-left-0' : ''} ${rowIndex % 2 === 0 ? 'tw-bg-[#F4F5F7]' : 'tw-bg-white'} ${className || ''}`}
            onClick={onClick}
            style={style}
            title={title}
        >
            {children}
        </td>
    );
};

export default TableCell;